import { render, staticRenderFns } from "./addcancel.vue?vue&type=template&id=30dd3b07&scoped=true"
import script from "./addcancel.vue?vue&type=script&lang=js"
export * from "./addcancel.vue?vue&type=script&lang=js"
import style0 from "./addcancel.vue?vue&type=style&index=0&id=30dd3b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd3b07",
  null
  
)

export default component.exports